export const cases = [
  {
    id: 'hollandsnieuwe',
    title: 'hollandsnieuwe',
    logo: 'stijn-bessem-clients-hollandsnieuwe.svg',
    intro: {
      img: {
        active:
          'cases/hollandsnieuwe/stijnbessem-case-hollandsnieuwe-intro-card1.2@2x.jpg',
        inactive:
          'cases/hollandsnieuwe/stijnbessem-case-hollandsnieuwe-intro-card1.1@2x.jpg',
      },
    },
    hero: {
      img: {
        active:
          'cases/hollandsnieuwe/stijn-bessem-case-hollandsnieuwe-00.1@2x.jpg',
        inactive:
          'cases/hollandsnieuwe/stijn-bessem-case-hollandsnieuwe-00.2@2x.jpg',
      },
    },
    categories: [
      {
        title: 'Agency',
        body: 'Chunk Creative Agency',
      },
      {
        title: 'Client',
        body:
          '<a href="http://www.hollandsnieuwe.nl/" target="_blank" rel="noreferrer">hollandsnieuwe</a>',
      },
      {
        title: 'Role',
        body: 'UI Design<br/>UX Consult<br/>Design System',
      },
      {
        title: 'Trophies',
        body:
          '<a href="https://www.indigoawards.com/winners/533" target="_blank" rel="noreferrer">Indigo</a><br/>Awwwards',
      },
    ],
    sections: [
      {
        type: 'bottom',
        img: {
          mobile: {
            x1:
              'cases/hollandsnieuwe/mobile/stijn-bessem-case-hollandsnieuwe-01.jpg',
            x2:
              'cases/hollandsnieuwe/mobile/stijn-bessem-case-hollandsnieuwe-01@2x.jpg',
          },
          desktop: {
            x1:
              'cases/hollandsnieuwe/desktop/stijn-bessem-case-hollandsnieuwe-01.jpg',
            x2:
              'cases/hollandsnieuwe/desktop/stijn-bessem-case-hollandsnieuwe-01@2x.jpg',
          },
        },
        content: {
          title: 'all about visual hierarchy',
          body: '',
        },
      },
      {
        type: 'full',
        img: {
          mobile: {
            x1:
              'cases/hollandsnieuwe/mobile/stijn-bessem-case-hollandsnieuwe-02.jpg',
            x2:
              'cases/hollandsnieuwe/mobile/stijn-bessem-case-hollandsnieuwe-02@2x.jpg',
          },
          desktop: {
            x1:
              'cases/hollandsnieuwe/desktop/stijn-bessem-case-hollandsnieuwe-02.jpg',
            x2:
              'cases/hollandsnieuwe/desktop/stijn-bessem-case-hollandsnieuwe-02@2x.jpg',
          },
        },
      },
      {
        type: 'left',
        video: {
          url:
            '//player.vimeo.com/video/359047986?autoplay=1&loop=1&autopause=0&background=1&muted=1',
          format: '16by9',
        },
        content: {
          title: 'design research',
          body: '',
        },
      },
      {
        type: 'right',
        video: {
          url:
            '//player.vimeo.com/video/359047525?autoplay=1&loop=1&autopause=0&background=1&muted=1',
          format: '16by9',
        },
        content: {
          title: 'Sustainable design system',
          body: '',
        },
      },
      {
        type: 'bottom',
        img: {
          mobile: {
            x1:
              'cases/hollandsnieuwe/mobile/stijn-bessem-case-hollandsnieuwe-03.jpg',
            x2:
              'cases/hollandsnieuwe/mobile/stijn-bessem-case-hollandsnieuwe-03@2x.jpg',
          },
          desktop: {
            x1:
              'cases/hollandsnieuwe/desktop/stijn-bessem-case-hollandsnieuwe-03.jpg',
            x2:
              'cases/hollandsnieuwe/desktop/stijn-bessem-case-hollandsnieuwe-03@2x.jpg',
          },
        },
        content: {
          title: 'promotional landingpages',
          body: '',
        },
      },
      {
        type: 'full',
        img: {
          mobile: {
            x1:
              'cases/hollandsnieuwe/mobile/stijn-bessem-case-hollandsnieuwe-04.jpg',
            x2:
              'cases/hollandsnieuwe/mobile/stijn-bessem-case-hollandsnieuwe-04@2x.jpg',
          },
          desktop: {
            x1:
              'cases/hollandsnieuwe/desktop/stijn-bessem-case-hollandsnieuwe-04.jpg',
            x2:
              'cases/hollandsnieuwe/desktop/stijn-bessem-case-hollandsnieuwe-04@2x.jpg',
          },
        },
      },
      {
        type: 'left',
        video: {
          url:
            '//player.vimeo.com/video/360785557?autoplay=1&loop=1&autopause=0&background=1&muted=1',
          format: '16by9',
        },
        content: {
          title: 'Design Showreel',
          body: '',
        },
      },
      {
        type: 'next',
        to: 'pickwick',
        img: {
          desktop: {
            x1: 'cases/pickwick/stijnbessem-case-pickwick-bottom-01.1@2x.jpg',
            x2: 'cases/pickwick/stijnbessem-case-pickwick-bottom-01.1@2x.jpg',
          },
        },
        content: {
          title: 'Pickwick',
        },
      },
    ],
  },
  {
    id: 'pickwick',
    title: 'Pickwick',
    logo: 'stijn-bessem-clients-pickwick.svg',
    intro: {
      img: {
        active: 'cases/pickwick/stijnbessem-case-pickwick-intro-card1.2@2x.jpg',
        inactive:
          'cases/pickwick/stijnbessem-case-pickwick-intro-card1.1@2x.jpg',
      },
    },
    hero: {
      img: {
        active: 'cases/pickwick/stijn-bessem-case-pickwick-00.1@2x.jpg',
        inactive: 'cases/pickwick/stijn-bessem-case-pickwick-00.2@2x.jpg',
      },
    },
    categories: [
      {
        title: 'Agency',
        body: 'Chunk Creative Agency',
      },
      {
        title: 'Client',
        body: 'Jacobs Douwe Egberts',
      },
      {
        title: 'Role',
        body: 'UI Design<br/>UX Consult<br/>Digital Strategy',
      },
      {
        title: 'Links',
        body:
          '<a href="http://www.pickwick.nl" target="_blank" rel="noreferrer">Pickwick</a>',
      },
    ],
    sections: [
      {
        type: 'bottom',
        video: {
          url:
            '//player.vimeo.com/video/359526493?autoplay=1&loop=1&autopause=0&background=1&muted=1',
          format: '16by9',
        },
        content: {
          title: 'Redesign everything',
          body: '',
        },
      },
      {
        type: 'full',
        img: {
          mobile: {
            x1: 'cases/pickwick/mobile/stijn-bessem-case-pickwick-02.jpg',
            x2: 'cases/pickwick/mobile/stijn-bessem-case-pickwick-02@2x.jpg',
          },
          desktop: {
            x1: 'cases/pickwick/desktop/stijn-bessem-case-pickwick-02.1.jpg',
            x2: 'cases/pickwick/desktop/stijn-bessem-case-pickwick-02.1@2x.jpg',
          },
        },
      },
      {
        type: 'left',
        img: {
          desktop: {
            x1: 'cases/pickwick/desktop/stijn-bessem-case-pickwick-03.1.jpg',
            x2: 'cases/pickwick/desktop/stijn-bessem-case-pickwick-03.1@2x.jpg',
          },
          mobile: {
            x1: 'cases/pickwick/mobile/stijn-bessem-case-pickwick-03.1.jpg',
            x2: 'cases/pickwick/mobile/stijn-bessem-case-pickwick-03.1@2x.jpg',
          },
        },
        content: {
          title: 'Responsive designs',
          body:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin justo arcu, efficitur sit amet elit vel, vestibulum porttitor arcu. Suspendisse ac vestibulum metus.',
        },
      },
      {
        type: 'full',
        img: {
          mobile: {
            x1: 'cases/pickwick/mobile/stijn-bessem-case-pickwick-04.jpg',
            x2: 'cases/pickwick/mobile/stijn-bessem-case-pickwick-04@2x.jpg',
          },
          desktop: {
            x1: 'cases/pickwick/desktop/stijn-bessem-case-pickwick-04.jpg',
            x2: 'cases/pickwick/desktop/stijn-bessem-case-pickwick-04@2x.jpg',
          },
        },
      },
      {
        type: 'next',
        to: 'voxi',
        img: {
          desktop: {
            x1: 'cases/voxi/stijnbessem-case-voxi-bottom-01.2@2x.jpg',
            x2: 'cases/voxi/stijnbessem-case-voxi-bottom-01.2@2x.jpg',
          },
        },
        content: {
          to: 'voxi',
          title: 'Voxi',
        },
      },
    ],
  },
  {
    id: 'voxi',
    title: 'VOXI',
    logo: 'stijn-bessem-clients-voxi.svg',
    intro: {
      img: {
        active: 'cases/voxi/stijnbessem-case-voxi-intro-card1.1@2x.jpg',
        inactive: 'cases/voxi/stijnbessem-case-voxi-intro-card1.2@2x.jpg',
      },
    },
    hero: {
      img: {
        active: 'cases/voxi/stijn-bessem-case-voxi-00.1@2x.jpg',
        inactive: 'cases/voxi/stijn-bessem-case-voxi-00.2@2x.jpg',
      },
    },
    categories: [
      {
        title: 'Agency',
        body: 'Chunk Creative Agency',
      },
      {
        title: 'Client',
        body: 'VOXI UK',
      },
      {
        title: 'Role',
        body: 'UI Design<br/>UX Consult<br/>Digital Style Guide',
      },
      {
        title: 'Links',
        body:
          '<a href="https://www.voxi.co.uk/" target="_blank" rel="noreferrer">voxi.co.uk</a><br/><a href="https://invis.io/4DTZVYL7XR9#/341591945_20180417_01_SB_VOXI_WAVOXI_M01-01" target="_blank" rel="noreferrer">inVision proto</a>',
      },
    ],
    sections: [
      {
        type: 'bottom',
        img: {
          desktop: {
            x1: 'cases/voxi/desktop/stijn-bessem-case-voxi-01.jpg',
            x2: 'cases/voxi/desktop/stijn-bessem-case-voxi-01@2x.jpg',
          },
          mobile: {
            x1: 'cases/voxi/mobile/stijn-bessem-case-voxi-01.jpg',
            x2: 'cases/voxi/mobile/stijn-bessem-case-voxi-01@2x.jpg',
          },
        },
        content: {
          title: 'Dark mode all the way',
          body: '',
        },
      },
      {
        type: 'full',
        img: {
          desktop: {
            x1: 'cases/voxi/desktop/stijn-bessem-case-voxi-02.jpg',
            x2: 'cases/voxi/desktop/stijn-bessem-case-voxi-02@2x.jpg',
          },
          mobile: {
            x1: 'cases/voxi/mobile/stijn-bessem-case-voxi-02.jpg',
            x2: 'cases/voxi/mobile/stijn-bessem-case-voxi-02@2x.jpg',
          },
        },
      },
      {
        type: 'left',
        video: {
          url:
            '//player.vimeo.com/video/359131217?autoplay=1&loop=1&autopause=0&background=1&muted=1',
          format: '1by1',
        },
        content: {
          title: "High Fidelity proto's",
          body: '',
        },
      },
      {
        type: 'right',
        img: {
          desktop: {
            x1: 'cases/voxi/desktop/stijn-bessem-case-voxi-04@2x.jpg',
            x2: 'cases/voxi/desktop/stijn-bessem-case-voxi-04@2x.jpg',
          },
          mobile: {
            x1: 'cases/voxi/mobile/stijn-bessem-case-voxi-04.jpg',
            x2: 'cases/voxi/mobile/stijn-bessem-case-voxi-04@2x.jpg',
          },
        },
        content: {
          title: 'Prototype for testing',
          body: '',
        },
      },
      {
        type: 'next',
        to: 't-mobile',
        img: {
          desktop: {
            x1: 'cases/tmobile/stijnbessem-case-t-mobile-bottom-01.1.jpg',
            x2: 'cases/tmobile/stijnbessem-case-t-mobile-bottom-01.1@2x.jpg',
          },
        },
        content: {
          title: 't-mobile',
        },
      },
    ],
  },
  {
    id: 't-mobile',
    title: 'T-Mobile',
    logo: 'stijn-bessem-clients-t-mobile.svg',
    intro: {
      img: {
        active: 'cases/tmobile/stijnbessem-case-t-mobile-intro-card1.2@2x.jpg',
        inactive:
          'cases/tmobile/stijnbessem-case-t-mobile-intro-card1.1@2x.jpg',
      },
    },
    hero: {
      img: {
        active: 'cases/tmobile/stijn-bessem-case-t-mobile-00.1@2x.jpg',
        inactive: 'cases/tmobile/stijn-bessem-case-t-mobile-00.2@2x.jpg',
      },
    },
    categories: [
      {
        title: 'Agency',
        body: 'Oberon',
      },
      {
        title: 'Client',
        body: 'T-Mobile',
      },
      {
        title: 'Role',
        body: 'UI Design<br/>UX Design',
      },
      {
        title: 'Links',
        body:
          '<a href="https://projects.invisionapp.com/share/WQB1LSSXB#/205812308_CEO_Login" target="_blank" rel="noreferrer">inVision proto</a>',
      },
    ],
    sections: [
      {
        type: 'bottom',
        img: {
          desktop: {
            x1: 'cases/tmobile/desktop/stijn-bessem-case-t-mobile-02.jpg',
            x2: 'cases/tmobile/desktop/stijn-bessem-case-t-mobile-02@2x.jpg',
          },
          mobile: {
            x1: 'cases/tmobile/mobile/stijn-bessem-case-t-mobile-01.jpg',
            x2: 'cases/tmobile/mobile/stijn-bessem-case-t-mobile-01@2x.jpg',
          },
        },
        content: {
          title: 'mobile first',
          body: '',
        },
      },
      {
        type: 'left',
        video: {
          url:
            '//player.vimeo.com/video/360525576?autoplay=1&loop=1&autopause=0&background=1&muted=1',
          format: '1by1',
        },
        content: {
          title: 'Prototype for testing',
          body: '',
        },
      },
      {
        type: 'full',
        img: {
          desktop: {
            x1: 'cases/tmobile/desktop/stijn-bessem-case-t-mobile-03.jpg',
            x2: 'cases/tmobile/desktop/stijn-bessem-case-t-mobile-03@2x.jpg',
          },
          mobile: {
            x1: 'cases/tmobile/mobile/stijn-bessem-case-t-mobile-03.jpg',
            x2: 'cases/tmobile/mobile/stijn-bessem-case-t-mobile-03@2x.jpg',
          },
        },
      },
      {
        type: 'bottom',
        video: {
          url:
            '//player.vimeo.com/video/360526890?autoplay=1&loop=1&autopause=0&background=1&muted=1',
          format: '16by9',
        },
        content: {
          title: 'Custom header animation',
          body: '',
        },
      },
      {
        type: 'next',
        to: 'douweegberts',
        img: {
          desktop: {
            x1:
              'cases/douweegberts/stijnbessem-case-douwe-egberts-bottom-01.1@2x.jpg',
            x2:
              'cases/douweegberts/stijnbessem-case-douwe-egberts-bottom-01.1@2x.jpg',
          },
        },
        content: {
          title: 'Douwe Egberts',
        },
      },
    ],
  },
  {
    id: 'douweegberts',
    title: 'Douwe Egberts',
    logo: 'stijn-bessem-clients-douwe-egberts.svg',
    intro: {
      img: {
        active:
          'cases/douweegberts/stijnbessem-case-douwe-egberts-intro-card1.1@2x.jpg',
        inactive:
          'cases/douweegberts/stijnbessem-case-douwe-egberts-intro-card1.2@2x.jpg',
      },
    },
    hero: {
      img: {
        active:
          'cases/douweegberts/stijn-bessem-case-douwe-egberts-00.2@2x.jpg',
        inactive:
          'cases/douweegberts/stijn-bessem-case-douwe-egberts-00.1@2x.jpg',
      },
    },
    categories: [
      {
        title: 'Agency',
        body: 'Chunk Creative Agency',
      },
      {
        title: 'Client',
        body: 'Jocobs Douwe Egberts',
      },
      {
        title: 'Role',
        body: 'UI Design<br/>UX Consult<br/>Design System',
      },
      {
        title: 'Links',
        body:
          '<a href="https://www.de.nl/" target="_blank" rel="noreferrer">Douwe Egberts</a>',
      },
    ],
    sections: [
      {
        type: 'bottom',
        video: {
          url:
            '//player.vimeo.com/video/359539578?autoplay=1&loop=1&autopause=0&background=1&muted=1',
          format: '16by9',
        },
        content: {
          title: 'Starting from scratch',
          body: '',
        },
      },
      {
        type: 'full',
        img: {
          desktop: {
            x1:
              'cases/douweegberts/desktop/stijn-bessem-case-douwe-egberts-02.1.jpg',
            x2:
              'cases/douweegberts/desktop/stijn-bessem-case-douwe-egberts-02.1@2x.jpg',
          },
          mobile: {
            x1:
              'cases/douweegberts/mobile/stijn-bessem-case-douwe-egberts-02.jpg',
            x2:
              'cases/douweegberts/mobile/stijn-bessem-case-douwe-egberts-02@2x.jpg',
          },
        },
      },
      {
        type: 'left',
        img: {
          desktop: {
            x1:
              'cases/douweegberts/desktop/stijn-bessem-case-douwe-egberts-03.jpg',
            x2:
              'cases/douweegberts/desktop/stijn-bessem-case-douwe-egberts-03@2x.jpg',
          },
          mobile: {
            x1:
              'cases/douweegberts/mobile/stijn-bessem-case-douwe-egberts-03.1.jpg',
            x2:
              'cases/douweegberts/mobile/stijn-bessem-case-douwe-egberts-03.1@2x.jpg',
          },
        },
        content: {
          title: 'Mobile First',
          body: '',
        },
      },

      {
        type: 'next',
        to: 'hedo',
        img: {
          desktop: {
            x1: 'cases/hedo/stijnbessem-case-hedo-bottom-01.2@2x.jpg',
            x2: 'cases/hedo/stijnbessem-case-hedo-bottom-01.2@2x.jpg',
          },
        },
        content: {
          title: 'HEDO',
        },
      },
    ],
  },
  {
    id: 'hedo',
    title: 'HEDO',
    logo: 'stijn-bessem-clients-hedo.svg',
    intro: {
      img: {
        active: 'cases/hedo/stijnbessem-case-hedo-intro-card1.2@2x.jpg',
        inactive: 'cases/hedo/stijnbessem-case-hedo-intro-card1.1@2x.jpg',
      },
    },
    hero: {
      img: {
        active: 'cases/hedo/stijn-bessem-case-hedo-00.2@2x.jpg',
        inactive: 'cases/hedo/stijn-bessem-case-hedo-00.1@2x.jpg',
      },
    },
    categories: [
      {
        title: 'Agency',
        body: 'Personal',
      },
      {
        title: 'Client',
        body: 'Hedo Smart Home',
      },
      {
        title: 'Role',
        body: 'UI Design<br/>UX Design<br/>Prototyping',
      },
      {
        title: 'Links',
        body:
          '<a href="https://projects.invisionapp.com/share/WBB1LOWTP#/screens/218715530_HEDO-Startup-01" target="_blank" rel="noreferrer">inVision proto</a>',
      },
    ],
    sections: [
      {
        type: 'bottom',
        img: {
          desktop: {
            x1: 'cases/hedo/desktop/stijn-bessem-case-hedo-01.png',
            x2: 'cases/hedo/desktop/stijn-bessem-case-hedo-01@2x.png',
          },
          mobile: {
            x1: 'cases/hedo/mobile/stijn-bessem-case-hedo-01.png',
            x2: 'cases/hedo/mobile/stijn-bessem-case-hedo-01@2x.png',
          },
        },
        content: {
          title: 'Luxury domotica software',
          body: '',
        },
      },
      {
        type: 'full',
        img: {
          desktop: {
            x1: 'cases/hedo/desktop/stijn-bessem-case-hedo-02.1.jpg',
            x2: 'cases/hedo/desktop/stijn-bessem-case-hedo-02.1@2x.jpg',
          },
          mobile: {
            x1: 'cases/hedo/mobile/stijn-bessem-case-hedo-02.1.jpg',
            x2: 'cases/hedo/mobile/stijn-bessem-case-hedo-02.1@2x.jpg',
          },
        },
      },
      {
        type: 'left',
        video: {
          url:
            '//player.vimeo.com/video/359737438?autoplay=1&loop=1&autopause=0&background=1&muted=1',
          format: '1by1',
        },
        content: {
          title: 'high fidelity proto',
          body: '',
        },
      },
      {
        type: 'bottom',
        img: {
          desktop: {
            x1: 'cases/hedo/desktop/stijn-bessem-case-hedo-04.jpg',
            x2: 'cases/hedo/desktop/stijn-bessem-case-hedo-04@2x.jpg',
          },
          mobile: {
            x1: 'cases/hedo/mobile/stijn-bessem-case-hedo-04.jpg',
            x2: 'cases/hedo/mobile/stijn-bessem-case-hedo-04@2x.jpg',
          },
        },
        content: {
          title: 'custom icon set',
          body: '',
        },
      },
      {
        type: 'right',
        img: {
          desktop: {
            x1: 'cases/hedo/desktop/stijn-bessem-case-hedo-03.jpg',
            x2: 'cases/hedo/desktop/stijn-bessem-case-hedo-03@2x.jpg',
          },
          mobile: {
            x1: 'cases/hedo/mobile/stijn-bessem-case-hedo-03.jpg',
            x2: 'cases/hedo/mobile/stijn-bessem-case-hedo-03@2x.jpg',
          },
        },
        content: {
          title: 'light mode included',
          body: '',
        },
      },
      {
        type: 'next',
        to: 'vodafonecvm',
        img: {
          desktop: {
            x1:
              'cases/vodafonecvm/stijnbessem-case-vodafonecvm-bottom-01.2.jpg',
            x2:
              'cases/vodafonecvm/stijnbessem-case-vodafonecvm-bottom-01.2@2x.jpg',
          },
        },
        content: {
          title: 'Vodafone',
        },
      },
    ],
  },
  {
    id: 'vodafonecvm',
    title: 'Vodafone',
    logo: 'stijn-bessem-logo-vodafone.svg',
    intro: {
      img: {
        active:
          'cases/vodafonecvm/stijnbessem-case-vodafonecvm-intro-card1.1@2x.jpg',
        inactive:
          'cases/vodafonecvm/stijnbessem-case-vodafonecvm-intro-card1.2@2x.jpg',
      },
    },
    hero: {
      img: {
        active: 'cases/vodafonecvm/stijn-bessem-case-vodafonecvm-00.2@2x.jpg',
        inactive: 'cases/vodafonecvm/stijn-bessem-case-vodafonecvm-00.1@2x.jpg',
      },
    },
    categories: [
      {
        title: 'Agency',
        body: 'Chunk Creative Agency',
      },
      {
        title: 'Client',
        body: 'Vodafone',
      },
      {
        title: 'Role',
        body: 'UX Design<br/>UI Design',
      },
      {
        title: 'Links',
        body:
          '<a href="https://www.vodafone.nl/inspiratie/" target="_blank" rel="noreferrer">Project page</a>',
      },
    ],
    sections: [
      {
        type: 'bottom',
        img: {
          desktop: {
            x1:
              'cases/vodafonecvm/desktop/stijn-bessem-case-vodafonecvm-02.jpg',
            x2:
              'cases/vodafonecvm/desktop/stijn-bessem-case-vodafonecvm-02@2x.jpg',
          },
          mobile: {
            x1: 'cases/vodafonecvm/mobile/stijn-bessem-case-vodafonecvm-02.jpg',
            x2:
              'cases/vodafonecvm/mobile/stijn-bessem-case-vodafonecvm-02@2x.jpg',
          },
        },
        content: {
          title: 'Clear wireframing',
          body: '',
        },
      },
      {
        type: 'full',
        img: {
          desktop: {
            x1:
              'cases/vodafonecvm/desktop/stijn-bessem-case-vodafonecvm-04.jpg',
            x2:
              'cases/vodafonecvm/desktop/stijn-bessem-case-vodafonecvm-04@2x.jpg',
          },
          mobile: {
            x1: 'cases/vodafonecvm/mobile/stijn-bessem-case-vodafonecvm-04.jpg',
            x2:
              'cases/vodafonecvm/mobile/stijn-bessem-case-vodafonecvm-04@2x.jpg',
          },
        },
      },
      {
        type: 'left',
        img: {
          desktop: {
            x1:
              'cases/vodafonecvm/desktop/stijn-bessem-case-vodafonecvm-03.jpg',
            x2:
              'cases/vodafonecvm/desktop/stijn-bessem-case-vodafonecvm-03@2x.jpg',
          },
          mobile: {
            x1: 'cases/vodafonecvm/mobile/stijn-bessem-case-vodafonecvm-03.jpg',
            x2:
              'cases/vodafonecvm/mobile/stijn-bessem-case-vodafonecvm-03@2x.jpg',
          },
        },
        content: {
          title: 'Mobile First',
          body: '',
        },
      },

      {
        type: 'next',
        to: 'vodafonerebranding',
        img: {
          desktop: {
            x1:
              'cases/vodafonerebranding/stijnbessem-case-vodafonerebranding-bottom-01.2@2x.jpg',
            x2:
              'cases/vodafonerebranding/stijnbessem-case-vodafonerebranding-bottom-01.2@2x.jpg',
          },
        },
        content: {
          title: 'Vodafone',
        },
      },
    ],
  },
  {
    id: 'vodafonerebranding',
    title: 'Vodafone',
    logo: 'stijn-bessem-logo-vodafone.svg',
    intro: {
      img: {
        active:
          'cases/vodafonerebranding/stijnbessem-case-vodafonerebranding-intro-card1.2@2x.jpg',
        inactive:
          'cases/vodafonerebranding/stijnbessem-case-vodafonerebranding-intro-card1.1@2x.jpg',
      },
    },
    hero: {
      img: {
        active:
          'cases/vodafonerebranding/stijn-bessem-case-vodafonereb-00.1@2x.jpg',
        inactive:
          'cases/vodafonerebranding/stijn-bessem-case-vodafonereb-00.2@2x.jpg',
      },
    },
    categories: [
      {
        title: 'Agency',
        body: 'Chunk Creative Agency',
      },
      {
        title: 'Client',
        body: 'Vodafone',
      },
      {
        title: 'Role',
        body: 'UI Design<br/>UX Consult',
      },
      {
        title: 'Links',
        body:
          '<a href="https://directsales.vodafone.nl/friendsfamily" target="_blank">Friends & Family</a><br/><a href="https://www.vodafone.nl/kleinbedrijf/advies/" target="_blank" rel="noreferrer">Advise Tool</a>',
      },
    ],
    sections: [
      {
        type: 'bottom',
        img: {
          desktop: {
            x1:
              'cases/vodafonerebranding/desktop/stijn-bessem-case-vodafonerebranding-01.jpg',
            x2:
              'cases/vodafonerebranding/desktop/stijn-bessem-case-vodafonerebranding-01@2x.jpg',
          },
          mobile: {
            x1:
              'cases/vodafonerebranding/mobile/stijn-bessem-case-vodafonerebranding-01.jpg',
            x2:
              'cases/vodafonerebranding/mobile/stijn-bessem-case-vodafonerebranding-01@2x.jpg',
          },
        },
        content: {
          title: 'New guidelines, new designs',
          body: '',
        },
      },
      {
        type: 'full',
        img: {
          desktop: {
            x1:
              'cases/vodafonerebranding/desktop/stijn-bessem-case-vodafonerebranding-02.jpg',
            x2:
              'cases/vodafonerebranding/desktop/stijn-bessem-case-vodafonerebranding-02@2x.jpg',
          },
          mobile: {
            x1:
              'cases/vodafonerebranding/mobile/stijn-bessem-case-vodafonerebranding-02.jpg',
            x2:
              'cases/vodafonerebranding/mobile/stijn-bessem-case-vodafonerebranding-02@2x.jpg',
          },
        },
      },
      {
        type: 'left',
        img: {
          desktop: {
            x1:
              'cases/vodafonerebranding/desktop/stijn-bessem-case-vodafonerebranding-03.jpg',
            x2:
              'cases/vodafonerebranding/desktop/stijn-bessem-case-vodafonerebranding-03@2x.jpg',
          },
          mobile: {
            x1:
              'cases/vodafonerebranding/mobile/stijn-bessem-case-vodafonerebranding-03.jpg',
            x2:
              'cases/vodafonerebranding/mobile/stijn-bessem-case-vodafonerebranding-03@2x.jpg',
          },
        },
        content: {
          title: 'Responsive designs',
          body: '',
        },
      },
      {
        type: 'right',
        img: {
          desktop: {
            x1:
              'cases/vodafonerebranding/desktop/stijn-bessem-case-vodafonerebranding-04.jpg',
            x2:
              'cases/vodafonerebranding/desktop/stijn-bessem-case-vodafonerebranding-04@2x.jpg',
          },
          mobile: {
            x1:
              'cases/vodafonerebranding/mobile/stijn-bessem-case-vodafonerebranding-04.jpg',
            x2:
              'cases/vodafonerebranding/mobile/stijn-bessem-case-vodafonerebranding-04@2x.jpg',
          },
        },
        content: {
          title: 'flow charts included',
          body: '',
        },
      },

      {
        type: 'next',
        to: 'kpito',
        img: {
          desktop: {
            x1: 'cases/kpito/stijnbessem-case-kpito-bottom-01.2@2x.jpg',
            x2: 'cases/kpito/stijnbessem-case-kpito-bottom-01.2@2x.jpg',
          },
        },
        content: {
          title: 'kPito',
        },
      },
    ],
  },
  {
    id: 'kpito',
    title: 'kpito',
    logo: 'stijn-bessem-clients-kpito.svg',
    intro: {
      img: {
        active: 'cases/kpito/stijnbessem-case-kpito-intro-card1.1@2x.jpg',
        inactive: 'cases/kpito/stijnbessem-case-kpito-intro-card1.2@2x.jpg',
      },
    },
    hero: {
      img: {
        active: 'cases/kpito/stijn-bessem-case-kpito-00.1@2x.jpg',
        inactive: 'cases/kpito/stijn-bessem-case-kpito-00.2@2x.jpg',
      },
    },
    categories: [
      {
        title: 'Agency',
        body: 'Oberon',
      },
      {
        title: 'Client',
        body: 'kPito',
      },
      {
        title: 'Role',
        body: 'UI Design<br/>UX Design',
      },
      {
        title: 'Links',
        body:
          '<a href="http://kpito.it/" target="_blank" rel="noreferrer">Project page</a>',
      },
    ],
    sections: [
      {
        type: 'bottom',
        img: {
          desktop: {
            x1: 'cases/kpito/desktop/stijn-bessem-case-kpito-01.jpg',
            x2: 'cases/kpito/desktop/stijn-bessem-case-kpito-01@2x.jpg',
          },
          mobile: {
            x1: 'cases/kpito/mobile/stijn-bessem-case-kpito-01.jpg',
            x2: 'cases/kpito/mobile/stijn-bessem-case-kpito-01@2x.jpg',
          },
        },
        content: {
          title: 'Back to school',
          body: '',
        },
      },
      {
        type: 'left',
        video: {
          url:
            '//player.vimeo.com/video/359786847?autoplay=1&loop=1&autopause=0&background=1&muted=1',
          format: '1by1',
        },
        content: {
          title: 'testing is essential',
          body: '',
        },
      },
      {
        type: 'right',
        img: {
          desktop: {
            x1: 'cases/kpito/desktop/stijn-bessem-case-kpito-02.jpg',
            x2: 'cases/kpito/desktop/stijn-bessem-case-kpito-02@2x.jpg',
          },
          mobile: {
            x1: 'cases/kpito/mobile/stijn-bessem-case-kpito-02.jpg',
            x2: 'cases/kpito/mobile/stijn-bessem-case-kpito-02@2x.jpg',
          },
        },
        content: {
          title: 'proud of the result',
          body: '',
        },
      },
      {
        type: 'left',
        img: {
          desktop: {
            x1: 'cases/kpito/desktop/stijn-bessem-case-kpito-03.jpg',
            x2: 'cases/kpito/desktop/stijn-bessem-case-kpito-03@2x.jpg',
          },
          mobile: {
            x1: 'cases/kpito/mobile/stijn-bessem-case-kpito-03.jpg',
            x2: 'cases/kpito/mobile/stijn-bessem-case-kpito-03@2x.jpg',
          },
        },
        content: {
          title: "it's been a succes",
          body: '',
        },
      },
      {
        type: 'next',
        to: 'teatopics',
        img: {
          desktop: {
            x1: 'cases/teatopics/stijnbessem-case-teatopics-bottom-01.2@2x.jpg',
            x2: 'cases/teatopics/stijnbessem-case-teatopics-bottom-01.2@2x.jpg',
          },
        },
        content: {
          title: 'teatopics',
        },
      },
    ],
  },
  {
    id: 'teatopics',
    title: 'teatopics',
    logo: 'stijn-bessem-clients-pickwick.svg',
    intro: {
      img: {
        active:
          'cases/teatopics/stijnbessem-case-teatopics-intro-card1.2@2x.jpg',
        inactive:
          'cases/teatopics/stijnbessem-case-teatopics-intro-card1.1@2x.jpg',
      },
    },
    hero: {
      img: {
        active: 'cases/teatopics/stijn-bessem-case-teatopics-00.1@2x.jpg',
        inactive: 'cases/teatopics/stijn-bessem-case-teatopics-00.2@2x.jpg',
      },
    },
    categories: [
      {
        title: 'Agency',
        body: 'Chunk Creative Agency',
      },
      {
        title: 'Client',
        body: 'Pickwick',
      },
      {
        title: 'Role',
        body: 'UI Design<br/>UX Consult',
      },
      {
        title: 'Links',
        body:
          '<a href="https://www.pickwick.nl/teatopics/" target="_blank" rel="noreferrer">Project page</a>',
      },
    ],
    sections: [
      {
        type: 'bottom',
        img: {
          desktop: {
            x1: 'cases/teatopics/desktop/stijn-bessem-case-teatopics-02.jpg',
            x2: 'cases/teatopics/desktop/stijn-bessem-case-teatopics-02@2x.jpg',
          },
          mobile: {
            x1: 'cases/teatopics/mobile/stijn-bessem-case-teatopics-02.jpg',
            x2: 'cases/teatopics/mobile/stijn-bessem-case-teatopics-02@2x.jpg',
          },
        },
        content: {
          title: 'a platform for collectors',
          body: '',
        },
      },
      {
        type: 'full',
        img: {
          desktop: {
            x1: 'cases/teatopics/desktop/stijn-bessem-case-teatopics-03.jpg',
            x2: 'cases/teatopics/desktop/stijn-bessem-case-teatopics-03@2x.jpg',
          },
          mobile: {
            x1: 'cases/teatopics/mobile/stijn-bessem-case-teatopics-03.jpg',
            x2: 'cases/teatopics/mobile/stijn-bessem-case-teatopics-03@2x.jpg',
          },
        },
      },
      {
        type: 'left',
        img: {
          desktop: {
            x1: 'cases/teatopics/desktop/stijn-bessem-case-teatopics-04.jpg',
            x2: 'cases/teatopics/desktop/stijn-bessem-case-teatopics-04@2x.jpg',
          },
          mobile: {
            x1: 'cases/teatopics/mobile/stijn-bessem-case-teatopics-04.jpg',
            x2: 'cases/teatopics/mobile/stijn-bessem-case-teatopics-04@2x.jpg',
          },
        },
        content: {
          title: 'custom artwork',
          body: '',
        },
      },
      {
        type: 'full',
        img: {
          desktop: {
            x1: 'cases/teatopics/desktop/stijn-bessem-case-teatopics-05.jpg',
            x2: 'cases/teatopics/desktop/stijn-bessem-case-teatopics-05@2x.jpg',
          },
          mobile: {
            x1: 'cases/teatopics/mobile/stijn-bessem-case-teatopics-05.jpg',
            x2: 'cases/teatopics/mobile/stijn-bessem-case-teatopics-05@2x.jpg',
          },
        },
      },
      {
        type: 'next',
        to: 'creative',
        img: {
          desktop: {
            x1: 'cases/creative/stijnbessem-case-creative-bottom-01.1.jpg',
            x2: 'cases/creative/stijnbessem-case-creative-bottom-01.1@2x.jpg',
          },
        },
        content: {
          to: 'creative',
          title: 'Creative',
        },
      },
    ],
  },
  {
    id: 'creative',
    title: 'Creative',
    logo: 'sb-logo-light.svg',
    intro: {
      img: {
        active: 'cases/creative/stijnbessem-case-creative-intro-card1.1@2x.jpg',
        inactive:
          'cases/creative/stijnbessem-case-creative-intro-card1.2@2x.jpg',
      },
    },
    hero: {
      img: {
        active: 'cases/creative/stijn-bessem-case-creative-header02@2x.jpg',
        inactive: 'cases/creative/stijn-bessem-case-creative-header01@2x.jpg',
      },
    },
    categories: [
      {
        title: 'Agency',
        body: 'Personal',
      },
      {
        title: 'Client',
        body: 'The Universe',
      },
      {
        title: 'Role',
        body: 'Art Director<br/>Artist',
      },
    ],
    sections: [
      {
        type: 'left',
        img: {
          desktop: {
            x1: 'cases/creative/desktop/stijn-bessem-case-creative-01.jpg',
            x2: 'cases/creative/desktop/stijn-bessem-case-creative-01@2x.jpg',
          },
          mobile: {
            x1: 'cases/creative/mobile/stijn-bessem-case-creative-01.jpg',
            x2: 'cases/creative/mobile/stijn-bessem-case-creative-01@2x.jpg',
          },
        },
        content: {
          title: 'Starting from scratch',
          body: '',
        },
      },
      {
        type: 'full',
        img: {
          desktop: {
            x1: 'cases/creative/desktop/stijn-bessem-case-creative-02.jpg',
            x2: 'cases/creative/desktop/stijn-bessem-case-creative-02@2x.jpg',
          },
          mobile: {
            x1: 'cases/creative/mobile/stijn-bessem-case-creative-02.jpg',
            x2: 'cases/creative/mobile/stijn-bessem-case-creative-02@2x.jpg',
          },
        },
      },
      {
        type: 'right',
        img: {
          desktop: {
            x1: 'cases/creative/desktop/stijn-bessem-case-creative-03.jpg',
            x2: 'cases/creative/desktop/stijn-bessem-case-creative-03@2x.jpg',
          },
          mobile: {
            x1: 'cases/creative/mobile/stijn-bessem-case-creative-03.jpg',
            x2: 'cases/creative/mobile/stijn-bessem-case-creative-03@2x.jpg',
          },
        },
        content: {
          title: 'old school Graffiti ',
          body: '',
        },
      },
      {
        type: 'full',
        img: {
          desktop: {
            x1: 'cases/creative/desktop/stijn-bessem-case-creative-04.jpg',
            x2: 'cases/creative/desktop/stijn-bessem-case-creative-04@2x.jpg',
          },
          mobile: {
            x1: 'cases/creative/mobile/stijn-bessem-case-creative-04.jpg',
            x2: 'cases/creative/mobile/stijn-bessem-case-creative-04@2x.jpg',
          },
        },
      },
      {
        type: 'left',
        img: {
          desktop: {
            x1: 'cases/creative/desktop/stijn-bessem-case-creative-05.jpg',
            x2: 'cases/creative/desktop/stijn-bessem-case-creative-05@2x.jpg',
          },
          mobile: {
            x1: 'cases/creative/mobile/stijn-bessem-case-creative-05.jpg',
            x2: 'cases/creative/mobile/stijn-bessem-case-creative-05@2x.jpg',
          },
        },
        content: {
          title: 'Wolf gang',
          body: '',
        },
      },
      {
        type: 'full',
        img: {
          desktop: {
            x1: 'cases/creative/desktop/stijn-bessem-case-creative-06.jpg',
            x2: 'cases/creative/desktop/stijn-bessem-case-creative-06@2x.jpg',
          },
          mobile: {
            x1: 'cases/creative/mobile/stijn-bessem-case-creative-06.jpg',
            x2: 'cases/creative/mobile/stijn-bessem-case-creative-06@2x.jpg',
          },
        },
      },
      {
        type: 'bottom',
        img: {
          mobile: {
            x1: 'cases/creative/mobile/stijn-bessem-case-creative-07.jpg',
            x2: 'cases/creative/mobile/stijn-bessem-case-creative-07@2x.jpg',
          },
          desktop: {
            x1: 'cases/creative/desktop/stijn-bessem-case-creative-07.jpg',
            x2: 'cases/creative/desktop/stijn-bessem-case-creative-07@2x.jpg',
          },
        },
        content: {
          title: 'Your next album cover',
          body: '',
        },
      },
      {
        type: 'next',
        to: 'chunk',
        img: {
          desktop: {
            x1: 'cases/chunk/stijnbessem-case-chunk-bottom-01.2.jpg',
            x2: 'cases/chunk/stijnbessem-case-chunk-bottom-01.2@2x.jpg',
          },
        },
        content: {
          to: 'chunk',
          title: 'chunk',
        },
      },
    ],
  },
  {
    id: 'chunk',
    title: 'chunk',
    logo: 'stijn-bessem-clients-chunk.svg',
    intro: {
      img: {
        active: 'cases/chunk/stijnbessem-case-chunk-intro-card02@2x.jpg',
        inactive: 'cases/chunk/stijnbessem-case-chunk-intro-card01@2x.jpg',
      },
    },
    hero: {
      img: {
        active: 'cases/chunk/stijn-bessem-case-chunk-header-02@2x.jpg',
        inactive: 'cases/chunk/stijn-bessem-case-chunk-header-01@2x.jpg',
      },
    },
    categories: [
      {
        title: 'Agency',
        body: 'Chunk Creative Agency',
      },
      {
        title: 'Client',
        body:
          '<a href="http://www.chunk.nl/" target="_blank" rel="noreferrer">Chunk Creative Agency</a>',
      },
      {
        title: 'Role',
        body: 'UI Design<br/>UX Design',
      },
      {
        title: 'Links',
        body:
          '<a href="https://invis.io/UQTZWEKRBEZ" target="_blank" rel="noreferrer">inVision proto</a>',
      },
    ],
    sections: [
      {
        type: 'bottom',
        img: {
          desktop: {
            x1: 'cases/chunk/desktop/stijn-bessem-case-chunk-01.jpg',
            x2: 'cases/chunk/desktop/stijn-bessem-case-chunk-01@2x.jpg',
          },
          mobile: {
            x1: 'cases/chunk/mobile/stijn-bessem-case-chunk-01.jpg',
            x2: 'cases/chunk/mobile/stijn-bessem-case-chunk-01@2x.jpg',
          },
        },
        content: {
          title: 'Customer Care Tool',
          body: '',
        },
      },
      {
        type: 'left',
        video: {
          url:
            '//player.vimeo.com/video/360812753?autoplay=1&loop=1&autopause=0&background=1&muted=1',
          format: '1by1',
        },
        content: {
          title: 'testing essential',
          body: '',
        },
      },
      {
        type: 'next',
        to: 'hollandsnieuwe',
        img: {
          desktop: {
            x1:
              'cases/hollandsnieuwe/stijnbessem-case-hollandsnieuwe-bottom-01.1.jpg',
            x2:
              'cases/hollandsnieuwe/stijnbessem-case-hollandsnieuwe-bottom-01.1@2x.jpg',
          },
        },
        content: {
          to: 'hollandsnieuwe',
          title: 'hollandsnieuwe',
        },
      },
    ],
  },
];
